import { NavLink, Tooltip } from "@mantine/core"
import { modals } from "@mantine/modals"
import Link from "next/link"
import { useTranslation } from "react-i18next"
import { AppTitle, icons } from "@/components/utils"
import { useAuth } from "@/hooks"
import { adminLink } from "@/utils/env"
import { useImpersonate } from "@/utils/impersonate"
import { Impersonate } from "./Impersonate"
import classes from "./SideMenu.module.css"

export function SuperNav({ collapsed }: { collapsed?: boolean }) {
  const { t } = useTranslation()
  const { user } = useAuth()
  const { value: impersonate } = useImpersonate()
  const finalUser = impersonate?.user ? { ...user, ...impersonate.user } : user

  if (!finalUser.is_super && !impersonate?.id) return null

  return (
    <>
      {!collapsed && <NavLink disabled pb={0} label={t("Admin")} classNames={classes} data-collapsed={collapsed} />}
      <Tooltip label="Admin" position="right" disabled={!collapsed}>
        <NavLink
          label={collapsed ? undefined : "Admin"}
          target="_blank"
          component={Link}
          href={adminLink}
          leftSection={<icons.Star />}
          classNames={classes}
          data-collapsed={collapsed}
        />
      </Tooltip>
      <Tooltip label="Impersonate" position="right" disabled={!collapsed}>
        <NavLink
          label={collapsed ? undefined : "Impersonate"}
          leftSection={<icons.Impersonate size="1.4rem" />}
          onClick={() => {
            modals.open({
              title: <AppTitle>Impersonate</AppTitle>,
              children: <Impersonate />,
            })
          }}
          classNames={classes}
          data-collapsed={collapsed}
        />
      </Tooltip>
    </>
  )
}
